import { UploadFile } from 'entities/uploadFiles'
import { AreaPhotosWrapper, SectionHeading } from './style'

type Photo = {
    id: number
    name: string
    hash_name?: string
    read_url?: string
    file_name?: string
    file?: File
}

interface AreasPhotosProps {
    cachedPhotos: Photo[]
    isEditable: boolean
    setNewFiles?: React.Dispatch<React.SetStateAction<Photo[]>>
    setRemovedFiles?: React.Dispatch<React.SetStateAction<Photo[]>>
    onChangeFile?: (newFiles: Photo[]) => void
    actions?: React.ReactNode[]
}

export function AreasPhotos({
    cachedPhotos,
    isEditable,
    setNewFiles = () => { },
    setRemovedFiles = () => { },
    onChangeFile = () => { },
    actions = []
}: AreasPhotosProps) {
    return (
        <AreaPhotosWrapper>
            <SectionHeading>Фотографии</SectionHeading>
            {actions}
            <div className='container'>
                <div className='row'>
                    <UploadFile
                        displayPhoto={true}
                        file={cachedPhotos}
                        disabled={isEditable}
                        onNewFilesChange={setNewFiles}
                        onRemovedFilesChange={setRemovedFiles}
                        onChangeFile={onChangeFile}
                    />
                </div>
            </div>
        </AreaPhotosWrapper>
    )
}
